import React from 'react';
import Form from 'devextreme-react/form';
import{userServices} from "../../services/user.service";
import { commonServices } from '../../services/common.service';
import { Button, TextBox } from 'devextreme-react';
import notify from 'devextreme/ui/notify';
import { twilioServices } from '../../services/twilio.service';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import PulseLoader from 'react-spinners/PulseLoader';
import { Popup } from 'devextreme-react/popup';

const formItems = [{
    itemType: 'group',
    cssClass: 'first-group',
    colCount: 1,
    items: [{dataField: 'userName'}, 
            {dataField: 'email'}, 
            {
                dataField: 'newPassword',
                editorOptions: {
                    mode: 'password',
                    placeholder:'Enter new password',
                }
            }, 
            {
                dataField: 'confirmPassword',
                editorOptions: {
                    mode: 'password',
                    placeholder:'Enter confirm password',
                }
            },
            {
                dataField: 'phoneNumber',
                editorOptions: {
                    mask: '+1 (X00) 000-0000',
                    maskRules: {
                        X: /[02-9]/
                    },
                    useMaskedValue: true,
                    maskInvalidMessage: 'The phone must have a correct USA phone format'
                }
            }]
}];

export class Register extends React.Component {
    constructor(props) {
        super(props);
        
        this.onRegisterClick = this.onRegisterClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.hidePopup = this.hidePopup.bind(this);
        this.onVerifyClick = this.onVerifyClick.bind(this);
        this.valueChanged = this.valueChanged.bind(this);

        this.setForm = (ref) => {
            if(ref!=null)
            {
                this.form = ref.instance;
            }
        };
        
        this.state = {verificationCode: "", loading: false, popupVisible: false, enteredCode:""};
    }
    showPopup(){
        this.setState({popupVisible: true});
    }
    hidePopup(){
        this.setState({popupVisible: false});
    }

    valueChanged(data) {
        this.setState({enteredCode: data.value});
    }

    onVerifyClick(e){
        if(this.state.enteredCode==this.state.verificationCode){
            notify({position:'top right', message:"Your phone number has been verified.", type:'success',maxWidth:200});
            this.hidePopup();

            //save to database
            var formData = this.form.option("formData");
            formData.phoneNumberConfirmed=true;
            formData.isEnabled=true;
            formData.roles=['parent'];
            formData.isValidateFlg = false;

            userServices.register(formData).then(
                response=>{
                    if(response){
                        notify({position:'top right', message:'Added successfully',type:'success',maxWidth:200});
                        
                        this.props.history.push('/');
                    }
                }, 
                error=>{
                    notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:300, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                    this.setState({loading:false});
                }
            );
        }
        else{
            notify({position:'top right', message:"Verification code is not correct.", type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
        }
    }

    onCancelClick(e){
        this.props.history.push('/');
    }

    onRegisterClick(e) {
        this.setState({loading:true});
        var formData = this.form.option("formData");
        if(formData.userName===''){
            notify({position:'top right', message:"User Name is required",type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            this.setState({loading:false});
            return;
        }
        if(formData.email===''){
            notify({position:'top right', message:"Email is required",type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            this.setState({loading:false});
            return;
        }
        if(formData.newPassword===''){
            notify({position:'top right', message:"Password is required",type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            this.setState({loading:false});
            return;
        }

        if(formData.newPassword!==formData.confirmPassword){
            notify({position:'top right', message:"Password and Confirm Password do not match",type:'error',maxWidth:300, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            this.setState({loading:false});
            return;
        }
        if(formData.phoneNumber===undefined){
            notify({position:'top right', message:"Phone number is required",type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            this.setState({loading:false});
            return;
        }

         //save to database
         var formData = this.form.option("formData");
         formData.phoneNumberConfirmed=true;
         formData.isEnabled=true;
         formData.roles=['parent'];
         formData.isValidateFlg = true;

         userServices.register(formData).then(
             response=>{
                 if(response ==""){
                  //generate verification code
                    var min=9999;
                    var max=99999;
                    var randomVerifyCode = Math.floor(Math.random() * (max - min + 1) ) + min;
                    this.setState({verificationCode:randomVerifyCode});
                    var messageBody="Spinrise phone number verification code is "+randomVerifyCode;

                    twilioServices.sendVerifySMS(formData.phoneNumber, messageBody).then(
                        data=>{
                            if(data ===true){
                                notify({position:'top right', message:"An SMS has been sent to your mobile phone.", type:'success',maxWidth:200});
                                this.showPopup();
                            }
                            else if(data ===false){
                                notify({position:'top right', message:"Phone number is invalid.", type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                            }
                        },
                        error=>{
                        notify({position:'top right', message:"Failed: cannot send verify SMS. "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                        console.log(error);
                        
                        }
                    );
                 }
             }, 
             error=>{
                 notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:300, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                 this.setState({loading:false});
             }
         );

        
        
        this.setState({loading:false});
    }
      
    render() {
        return (
            <div style={{padding: "60px 0"}}>
                <div style={{maxWidth:"500px", margin:"auto", textAlign:"center"}}>
                    <h3>Registration</h3>
                    <div style={{textAlign:"right"}}>
                        <div style={{marginLeft:"25px"}}>
                            <Form items={formItems} ref={this.setForm} style={{textAlign:"right"}}/>
                        </div>
                    </div>
                    <br/>
                    <Button
                        key='btnRegister'
                        width={80}
                        height={30}
                        text='Register'
                        type='default'
                        stylingMode='contained'
                        onClick={this.onRegisterClick}
                    />
                    &nbsp;&nbsp;
                    <Button
                        key='btnCancel'
                        width={80}
                        height={30}
                        text='Cancel'
                        type='default'
                        stylingMode='contained'
                        onClick={this.onCancelClick}
                    />

                    <Popup
                        className={'popup'}
                        visible={this.state.popupVisible}
                        onHiding={this.hidePopup}
                        dragEnabled={false}
                        closeOnOutsideClick={false}
                        showTitle={true}
                        title={'Phone number verification'}
                        width={300}
                        height={150}
                    >
                        <div style={{textAlign:"center", paddingTop:"20px"}}>
                            <TextBox placeholder={'Enter code here...'} onValueChanged={this.valueChanged} />
                            <br/>
                            <Button
                                key='btnVerify'
                                width={80}
                                height={30}
                                text='Verify'
                                type='default'
                                stylingMode='contained'
                                onClick={this.onVerifyClick}
                            />
                        </div>
                    </Popup>
                </div>
                <br/>
                <div className='sweet-loading' style={{textAlign:"center"}}>
                    <PulseLoader
                        color={'#36D7B7'}
                        loading={this.state.loading}
                    />
                </div>
            </div> 
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Register.js